export default "assets/images/home-logo-0abcf92a.png";